import { useMemo } from 'react'

/**
 * Фильтрация табличных данных по строке поиска и выбранному полю.
 * @param {T[]} tableData - исходные данные
 * @param {string|undefined} globalFilter - строка поиска
 * @param {string} searchField - ключ поля для поиска
 * @param {(row: T, field: string) => unknown} [getRowSearchValue] - как получить значение из строки (по умолчанию row[field])
 * @returns {T[]} отфильтрованный массив
 */
export function useFilteredBySearch(tableData, globalFilter, searchField, getRowSearchValue) {
  return useMemo(() => {
    if (!globalFilter || typeof globalFilter !== 'string') return tableData
    const q = String(globalFilter).toLowerCase().trim()
    if (!q) return tableData
    const getVal = getRowSearchValue ?? ((row, field) => row[field])
    return tableData.filter((row) => {
      try {
        const raw = getVal(row, searchField)
        // Convert null/undefined to empty string to allow searching on optional fields
        const normalized = String(raw ?? '').toLowerCase().trim()
        if (!normalized) return false
        return normalized.includes(q)
      } catch {
        return false
      }
    })
  }, [tableData, globalFilter, searchField, getRowSearchValue])
}
